import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import image1 from "../../../../../assets/orderingSystem/burger.jpeg";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../../../slices/cart/cartSlice";
import ProductItemServices from "../../../../../services/OrderingServices/ProductItemService";
import toast from "react-hot-toast";
import restro from "../../../../../assets/orderingSystem/restrologo.png";
import ItemService from "../../../../../services/OrderingServices/ItemService";
import SpicyLevelSelector from "../../../../SpicyLevelSelector/SpicyLevelSelector";

const ProductDetailModal = ({
  isOpen,
  toggle,
  selectedItem,
  count,
  setCount,
  setComplimentaryCount,
  setSelectedAttributes,
  selectedAttributes,
  handleAddToCart,
  setNotes,
  notes,
  setComplementary,
  complementary,
  loading,
  setSelectedChildAttributes,
  selectedChildAttributes,
}) => {
  console.log(
    "🚀 ~ ProductDetailModal ~ selectedChildAttributes:",
    selectedChildAttributes
  );
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.items);
  const [currentStep, setCurrentStep] = useState(1);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const shouldShowSpicyLevel = user?.shouldShowSpicyLevel;
  // const shouldShowSpicyLevel = true;

  // // --- spicy levels ---
  // const spicyLevel = {
  //   1: "Not Spicy",
  //   2: "Mild",
  //   3: "Medium",
  //   4: "Spicy",
  //   5: "Very Spicy",
  //   6: "Extra Spicy",
  // };

  // --- handle attribute selection (parent attributes) ---
  // const handleSelectAttribute = (itemId, attrName, attributeData) => {
  //   setSelectedAttributes((prev) => ({
  //     ...prev,
  //     [itemId]: {
  //       ...(prev[itemId] || {}),
  //       [attrName]: {
  //         ...attributeData,
  //         spicyLevel: prev[itemId]?.[attrName]?.spicyLevel || 0, // Preserve existing spicyLevel
  //       },
  //     },
  //   }));
  // };

  const handleSelectAttribute = (itemId, attrName, attributeData) => {
    setSelectedAttributes((prev) => {
      const currentAttr = prev[itemId]?.[attrName];

      // If the same attribute is already selected, unselect it
      if (currentAttr?.title === attributeData.title) {
        const updated = { ...prev };

        // Remove the specific attribute
        delete updated[itemId]?.[attrName];

        // If no attributes remain for this item, remove the item key entirely
        if (Object.keys(updated[itemId] || {}).length === 0) {
          delete updated[itemId];
        }

        return { ...updated };
      }

      // Otherwise, select it
      return {
        ...prev,
        [itemId]: {
          ...(prev[itemId] || {}),
          [attrName]: {
            ...attributeData,
            spicyLevel: prev[itemId]?.[attrName]?.spicyLevel || 0,
          },
        },
      };
    });
  };

  // --- update spicy level for parent attributes ---
  const handleParentSpicyChange = (itemId, spicyLevel, event) => {
    // Prevent event bubbling to parent div
    event?.stopPropagation();

    setSelectedAttributes((prev) => {
      const option = prev[itemId]?.Option || {};
      return {
        ...prev,
        [itemId]: {
          ...prev[itemId],
          Option: { ...option, spicyLevel: parseInt(spicyLevel) },
        },
      };
    });
  };

  // --- handle attribute selection (child attributes) ---
  const handleSelectChildAttribute = (
    itemId,
    productName,
    productPrice,
    item,
    attribute,
    index
  ) => {
    console.log("🚀 ~ handleSelectChildAttribute ~ attribute:", attribute);
    console.log(
      "🚀 ~ handleSelectChildAttribute ~ productPrice:",
      productPrice
    );
    setSelectedChildAttributes((prev) => {
      const existingItem = prev.find((entry) => entry.productId === itemId);
      const currentSelections = existingItem ? existingItem.attributes : [];
      const maxChoices = item.choices || 1;

      const isAlreadySelected = currentSelections.some(
        (attr) => attr.title === attribute.title
      );

      let updatedAttributes;
      if (isAlreadySelected) {
        updatedAttributes = currentSelections.filter(
          (attr) => attr.title !== attribute.title
        );
      } else {
        if (currentSelections.length >= maxChoices) {
          updatedAttributes = [
            ...currentSelections.slice(1),
            { title: attribute.title, value: attribute.value, spicyLevel: 0 },
          ];
        } else {
          updatedAttributes = [
            ...currentSelections,
            { title: attribute.title, value: attribute.value, spicyLevel: 0 },
          ];
        }
      }

      const updatedSelections = prev.filter(
        (entry) => entry.productId !== itemId
      );
      console.log(
        "🚀 ~ handleSelectChildAttribute ~ updatedSelections:",
        updatedSelections
      );
      if (updatedAttributes.length > 0) {
        updatedSelections.push({
          productId: itemId,
          productName,
          productPrice,
          attributes: updatedAttributes,
        });
      }

      // Note: Removed auto-advance logic - will be handled in spicy level change
      return updatedSelections;
    });
  };

  // --- update spicy level for child attributes ---
  const handleChildSpicyChange = (
    itemId,
    attributeTitle,
    spicyLevel,
    event,
    itemIndex,
    item
  ) => {
    event?.stopPropagation();

    setSelectedChildAttributes((prev) => {
      const updatedSelections = prev.map((entry) =>
        entry.productId === itemId
          ? {
              ...entry,
              attributes: entry.attributes.map((attr) =>
                attr.title === attributeTitle
                  ? { ...attr, spicyLevel: parseInt(spicyLevel) || 1 } // default fallback to 1
                  : attr
              ),
            }
          : entry
      );

      // ✅ Always consider spicyLevel >= 1 (since "Not Spicy" = 1 is default)
      const currentItem = updatedSelections.find(
        (entry) => entry.productId === itemId
      );

      const maxChoices = item?.choices || 1;
      const hasCompletedSelections =
        currentItem?.attributes?.length === maxChoices &&
        currentItem.attributes.every((attr) => attr.spicyLevel >= 1);

      if (hasCompletedSelections) {
        // Move to next child item
        const nextStep = itemIndex + 2;
        setCurrentStep((prevStep) => Math.max(prevStep, nextStep));

        if (itemIndex < data?.children?.length - 1) {
          toggleAccordion(`${nextStep}`);
        } else {
          toggleAccordion(null);
        }
      }

      return updatedSelections;
    });
  };

  const handleComplementary = () => setComplementary((prev) => !prev);

  const [data, setData] = useState();
  const fetchDetail = async () => {
    try {
      const response = await ItemService.getDetail(selectedItem?.id);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  // Calculate total price
  const calculateTotalPrice = () => {
    if (!data) return 0;

    let total = data.price || 0; // base product price

    // Add selected children prices
    selectedChildAttributes.forEach((child) => {
      const childPrice = child.productPrice || 0;
      const attributesPrice = child.attributes.reduce(
        (sum, attr) => sum + (attr.value || 0),
        0
      );
      total += childPrice + attributesPrice;
    });

    // Multiply by quantity
    total *= count;

    return total;
  };

  useEffect(() => {
    fetchDetail();
  }, [selectedItem?.id]);

  const [openAccordion, setOpenAccordion] = useState("1");
  const toggleAccordion = (id) => {
    if (openAccordion === id) {
      setOpenAccordion();
    } else {
      setOpenAccordion(id);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setComplementary(null);
      setSelectedChildAttributes([]);
      setSelectedAttributes([]);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="item-detail-modal rounded-4 border-0 shadow-lg"
      size="lg"
      scrollable
    >
      <ModalBody className="bg-light p-4">
        <button className="btn position-absolute top-0 end-0 " onClick={toggle}>
          <i className="bx bx-x fs-2 text-muted"></i>
        </button>
        <Row>
          {/* Image Section */}
          <Col
            lg={4}
            className="d-flex justify-content-center align-items-center"
          >
            <img
              src={data?.image || restro}
              className="rounded-4 w-100"
              style={{ maxHeight: "250px", objectFit: "cover" }}
              alt={data?.title}
            />
          </Col>

          {/* Content Section */}
          <Col lg={8}>
            <div className="mb-3">
              <h3 className="fw-bold text-dark mb-2">{data?.name}</h3>
              <p className="text-muted small">{data?.description}</p>
            </div>
            {/* Price & Quantity */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              {/* <h3 className="text-success fw-bold">Rs. {data?.price}</h3> */}
              <h3 className="text-success fw-bold">
                Rs. {calculateTotalPrice().toFixed(2)}
              </h3>

              <div className="input-step flex-shrink-0 border rounded-pill bg-white shadow-sm px-2">
                <button
                  type="button"
                  className="btn btn-light border-0 rounded-circle px-2"
                  onClick={() => setCount((prev) => Math.max(1, prev - 1))}
                  disabled={count <= 1}
                >
                  –
                </button>
                <input
                  type="number"
                  className="form-control border-0 text-center fw-bold"
                  style={{ width: "60px" }}
                  value={count}
                  onChange={(e) =>
                    setCount(
                      Math.max(1, Math.min(100, parseInt(e.target.value) || 1))
                    )
                  }
                  min="1"
                  max="100"
                />
                <button
                  type="button"
                  className="btn btn-light border-0 rounded-circle px-2"
                  onClick={() => setCount((prev) => Math.min(100, prev + 1))}
                >
                  +
                </button>
              </div>
            </div>
            {/* Complementary Switch */}{" "}
            <div className="d-flex justify-content-between align-items-center mb-3">
              {" "}
              <Label check htmlFor="isComplementary" className="fw-semibold">
                {" "}
                Complementary{" "}
              </Label>{" "}
              <FormGroup check className="form-switch">
                {" "}
                <Input
                  type="switch"
                  id="isComplementary"
                  checked={complementary}
                  onChange={handleComplementary}
                />{" "}
              </FormGroup>{" "}
            </div>
            {/* Attributes (Parent) */}
            {data?.attributes?.length > 0 && (
              <div className="mb-4">
                <Label className="fw-semibold mb-2">Attributes</Label>
                <div className="d-flex flex-wrap gap-2">
                  {data?.attributes.map((attribute, attrIndex) => {
                    const isSelected =
                      selectedAttributes[data.id]?.["Option"]?.title ===
                      attribute.title;
                    // const currentSpicyLevel =
                    //   selectedAttributes[data.id]?.["Option"]?.spicyLevel || 0;

                    return (
                      <div
                        key={attrIndex}
                        className={`attribute-pill px-3 py-2 rounded-3 shadow-sm ${
                          isSelected
                            ? "bg-success bg-opacity-50"
                            : "bg-white text-dark"
                        }`}
                        style={{
                          flex: "0 0 calc(50% - 0.5rem)",
                        }}
                      >
                        <div
                          onClick={() =>
                            handleSelectAttribute(data.id, "Option", attribute)
                          }
                          className="d-flex justify-content-between w-100 small fw-semibold"
                          style={{ cursor: "pointer" }}
                        >
                          <span>{attribute.title}</span>
                        </div>
                        {/* {isSelected && (
                          <div className="mt-2">
                            <label className="small fw-semibold text-muted">
                              Spicy Level
                            </label>
                            <select
                              className="form-select form-select-sm mt-1"
                              value={currentSpicyLevel}
                              onChange={(e) =>
                                handleParentSpicyChange(
                                  data.id,
                                  e.target.value,
                                  e
                                )
                              }
                              onClick={(e) => e.stopPropagation()}
                            >
                              <option value={0}>Select</option>
                              {Object.entries(spicyLevel).map(
                                ([level, label]) => (
                                  <option key={level} value={level}>
                                    {label}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        )} */}

                        {isSelected && (
                          <SpicyLevelSelector
                            currentSpicyLevel={
                              selectedAttributes[data.id]?.["Option"]
                                ?.spicyLevel || 0
                            }
                            onChange={(e) =>
                              handleParentSpicyChange(
                                data.id,
                                e.target.value,
                                e
                              )
                            }
                            onStopPropagation={(e) => e.stopPropagation()}
                            shouldShowTable={shouldShowSpicyLevel}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {data?.children?.map((item, index) => {
              const step = index + 1;
              const isDisabled = step > currentStep;
              const itemId = item.id || index;
              const selectedItem = Array.isArray(selectedChildAttributes)
                ? selectedChildAttributes.find(
                    (entry) => entry.productId === itemId
                  )
                : null;
              const selectedAttrs = selectedItem?.attributes || [];
              const displayPrice = selectedAttrs.reduce(
                (total, attr) => total + (attr.value || 0),
                item?.price || 0
              );

              return (
                <Accordion
                  open={openAccordion}
                  toggle={() => toggleAccordion(`${step}`)}
                  key={index}
                  className="mb-3 border rounded-3 shadow-sm"
                >
                  <AccordionItem>
                    <AccordionHeader targetId={`${step}`} className="fw-bold">
                      <div className="d-flex justify-content-between w-100 align-items-center">
                        <span>
                          {item?.name || "Unnamed Product"}
                          {selectedAttrs.length > 0 && (
                            <span className="text-muted ms-2">
                              (
                              {selectedAttrs
                                .map((attr) => attr.title)
                                .join(", ")}
                              )
                            </span>
                          )}
                        </span>
                        {displayPrice > 0 && (
                          <span className="text-muted small">
                            Rs. {displayPrice.toFixed(2)}
                          </span>
                        )}
                      </div>
                    </AccordionHeader>
                    <AccordionBody accordionId={`${step}`} className="bg-light">
                      <div className="row">
                        {item?.attributes?.map((attribute, attrIndex) => {
                          const isSelected = selectedAttrs?.some(
                            (attr) => attr.title === attribute.title
                          );

                          return (
                            <div key={attrIndex} className="col-12">
                              <div
                                className={`attribute-pill px-3 py-2 rounded-3 shadow-sm mb-2 ${
                                  isSelected
                                    ? "bg-success bg-opacity-50 text-dark"
                                    : "bg-white text-dark"
                                }`}
                                style={{ transition: "all 0.2s ease-in-out" }}
                              >
                                <div
                                  onClick={() =>
                                    handleSelectChildAttribute(
                                      itemId,
                                      item?.name,
                                      item?.price,
                                      item,
                                      attribute,
                                      index
                                    )
                                  }
                                  className="d-flex justify-content-between w-100 small fw-semibold"
                                  style={{ cursor: "pointer" }}
                                >
                                  <span>{attribute.title}</span>
                                  {attribute.value > 0 && (
                                    <span className="text-dark">
                                      + Rs. {attribute.value.toFixed(2)}
                                    </span>
                                  )}
                                </div>{" "}
                                {isSelected && (
                                  <SpicyLevelSelector
                                    currentSpicyLevel={
                                      selectedAttributes[data.id]?.["Option"]
                                        ?.spicyLevel || 0
                                    }
                                    onChange={(e) =>
                                      handleParentSpicyChange(
                                        data.id,
                                        e.target.value,
                                        e
                                      )
                                    }
                                    onStopPropagation={(e) =>
                                      e.stopPropagation()
                                    }
                                    shouldShowTable={shouldShowSpicyLevel}
                                  />
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              );
            })}
            {/* Child Items */}
            {/* {data?.children?.map((item, index) => {
              const step = index + 1;
              const isDisabled = step > currentStep;
              const itemId = item.id || index;

              const selectedItem = Array.isArray(selectedChildAttributes)
                ? selectedChildAttributes?.find(
                    (entry) => entry?.productId === itemId
                  )
                : null;
              const selectedAttrs = selectedItem?.attributes || [];

              return (
                <Accordion
                  open={isDisabled ? "" : openAccordion}
                  toggle={
                    isDisabled ? () => {} : () => toggleAccordion(`${step}`)
                  }
                  key={index}
                  className="mb-3 border rounded-3 shadow-sm"
                >
                  <AccordionItem>
                    <AccordionHeader targetId={`${step}`}>
                      <div className="d-flex justify-content-between w-100 align-items-center">
                        <span>
                          {item?.name}
                          {selectedAttrs.length > 0 && (
                            <span className="text-muted ms-2">
                              (
                              {selectedAttrs
                                .map(
                                  (attr) =>
                                    `${attr.title}${
                                      attr.spicyLevel > 0
                                        ? ` - ${spicyLevel[attr.spicyLevel]}`
                                        : ""
                                    }`
                                )
                                .join(", ")}
                              )
                            </span>
                          )}
                        </span>
                      </div>
                    </AccordionHeader>
                    <AccordionBody accordionId={`${step}`} className="bg-light">
                      <div className="row">
                        {item?.attributes?.map((attribute, attrIndex) => {
                          const isSelected = selectedAttrs?.some(
                            (attr) => attr.title === attribute.title
                          );
                          const selectedAttr = selectedAttrs?.find(
                            (attr) => attr.title === attribute.title
                          );
                          const currentSpicyLevel =
                            selectedAttr?.spicyLevel || 0;

                          return (
                            <div key={attrIndex} className="col-12">
                              <div
                                className={`attribute-pill px-3 py-2 rounded-3 shadow-sm mb-2 ${
                                  isSelected
                                    ? "bg-success bg-opacity-50 text-dark"
                                    : "bg-white text-dark"
                                }`}
                              >
                                <div
                                  onClick={() =>
                                    handleSelectChildAttribute(
                                      itemId,
                                      item?.name,
                                      item?.price,
                                      item,
                                      attribute,
                                      index
                                    )
                                  }
                                  className="d-flex justify-content-between align-content-center align-items-center w-100 small fw-semibold"
                                  style={{ cursor: "pointer" }}
                                >
                                  <span>{attribute?.title}</span>
                                  <div className="d-flex justify-content-center gap-3 align-content-center align-items-center">
                                    {isSelected && (
                                      <div className="">
                                        <select
                                          className="form-select form-select-sm"
                                          value={currentSpicyLevel || 1} // default to "Not Spicy"
                                          onChange={(e) =>
                                            handleChildSpicyChange(
                                              itemId,
                                              attribute.title,
                                              e.target.value,
                                              e,
                                              index,
                                              item
                                            )
                                          }
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          {Object.entries(spicyLevel).map(
                                            ([level, label]) => (
                                              <option key={level} value={level}>
                                                {label}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    )}
                                    {attribute.value > 0 && (
                                      <span className="text-dark">
                                        + Rs. {attribute.value.toFixed(2)}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              );
            })} */}
            {/* Notes */}
            <div className="">
              <Label check htmlFor="Note" className="fw-semibold mb-2">
                Note
              </Label>
              <textarea
                className="form-control shadow-sm rounded-3"
                rows="2"
                placeholder="Add some notes"
                value={notes}
                onChange={(e) => setNotes(e.target?.value)}
              ></textarea>
            </div>
          </Col>
        </Row>
      </ModalBody>
      {/* Footer Buttons */}
      <div className="d-flex justify-content-end gap-3 p-3 bg-light border-top">
        <button
          className="btn btn-outline-danger rounded-pill fw-semibold"
          onClick={toggle}
        >
          Cancel
        </button>
        <button
          className="btn btn-success rounded-pill fw-semibold"
          onClick={handleAddToCart}
          disabled={loading}
        >
          {loading ? (
            <Spinner />
          ) : complementary ? (
            "Add Complementary"
          ) : (
            "Add to Order"
          )}
        </button>
      </div>
    </Modal>
  );
};

export default ProductDetailModal;
